import React, { useContext } from "react";
import { Tooltip } from "antd";
import { ToolFnContext } from "../../utils/context";
import { isWin } from "../../utils/isWin";

export const GenContent = ({
  data,
  textStyle,
}: {
  data: IMultiElementCombineMsg.ITextAttr;
  textStyle: IMultiElementCombineMsg.IPlainTextStyle;
}) => {
  const {
    id,
    text_color,
    text_size,
    text_weight,
    content,
    jump_type, // scheme jssdk
    jump_scheme,
    sdk_api,
    sdk_param,
    preset_ctx,
    bold, // 是否粗体
    text_background_color, // 文本背景色
    italics, // 是否斜体
  } = data;
  const { textFiltering, contentJumpHandle, track } = useContext(ToolFnContext);
  // 注释: verticalAlign: "middle" 是后来加的，为了与图片居中对齐
  // text 组件的表现和移动端的不一致， 目前不支持文本图片混排的情况
  let style: IMultiElementCombineMsg.ITextStyle = {
    ...textStyle,
    display: "inline",
    verticalAlign: "middle",
    backgroundColor: "transparent",
    fontStyle: "normal",
  };
  text_color && (style.color = `#${text_color}`);
  text_size && (style.fontSize = `${text_size}px`);
  text_weight && (style.fontWeight = text_weight);
  jump_type && (style.cursor = "pointer");
  bold && (style.fontWeight = isWin() ? 600 : 500); // macOS 500 Windows 600
  text_background_color &&
    (style.backgroundColor = `#${text_background_color}`);
  italics && (style.fontStyle = "italic");

  return (
    <span
      style={style}
      key={id}
      onClick={() => {
        if (contentJumpHandle) {
          contentJumpHandle({
            jump_type,
            jump_scheme,
            sdk_api,
            sdk_param,
            preset_ctx,
          });
        } else if (jump_scheme) {
          window.open(jump_scheme);
        }

        if (track && id) {
          track(id, "button");
        }
      }}
      dangerouslySetInnerHTML={{
        // todo:
        // __html: getTextOfLink(content),
        __html: textFiltering(content),
      }}
    ></span>
  );
};

export const genContentByAttrs = (
  attrs: IMultiElementCombineMsg.ITextAttr[] = [],
  textStyle?: IMultiElementCombineMsg.IPlainTextStyle
): (JSX.Element | null)[] | null => {
  return attrs.length > 0
    ? attrs.map((item) => {
        const {
          id,
          content,
          icon_url,
          icon_width = 20,
          icon_height = 20,
          icon_jump_url,
        } = item;
        if (icon_url) {
          const imgElem = (
            <img
              src={`${icon_url}`}
              onError={() => {
                // todo:
                // (e.target as any).src = require("@/assets/images/error-icon.png");
              }}
              style={{
                display: "inline-block",
                width: `${icon_width}px`,
                height: `${icon_height}px`,
                cursor: content || icon_jump_url ? "pointer" : "default",
              }}
              key={id}
              onClick={() => icon_jump_url && window.open(icon_jump_url)}
            />
          );
          return content ? (
            <Tooltip placement="top" title={content}>
              {imgElem}
            </Tooltip>
          ) : (
            imgElem
          );
        } else if (content) {
          return (
            <GenContent data={item} textStyle={textStyle ? textStyle : {}} />
          );
        } else {
          return null;
        }
      })
    : null;
};
